export default __webpack_public_path__ + "static/media/ExperientialLearning.1bb085ad.svg";